"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CompanyReviewFormModel", {
    enumerable: true,
    get: function() {
        return CompanyReviewFormModel;
    }
});
const _bson = require("bson");
const _zod = /*#__PURE__*/ _interop_require_default(require("zod"));
const _utilsisomorphic = require("@performyard/utils-isomorphic");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const CompanyReviewFormModel = _zod.default.object({
    baseId: _zod.default.instanceof(_bson.ObjectId),
    name: _zod.default.string(),
    _id: _zod.default.instanceof(_bson.ObjectId),
    company: _zod.default.instanceof(_bson.ObjectId),
    createdAt: _utilsisomorphic.transformDateToUTCString,
    creator: _zod.default.object({
        name: _zod.default.string(),
        _id: _zod.default.instanceof(_bson.ObjectId).nullable()
    }),
    updatedAt: _utilsisomorphic.transformDateToUTCString.nullish(),
    updatedBy: _zod.default.object({
        name: _zod.default.string(),
        _id: _zod.default.instanceof(_bson.ObjectId).nullish()
    }).nullish(),
    deletedAt: _utilsisomorphic.transformDate.nullish(),
    deletedBy: _zod.default.object({
        name: _zod.default.string(),
        _id: _zod.default.instanceof(_bson.ObjectId).nullish()
    }).nullish(),
    goalCreation: _zod.default.boolean(),
    goalDiscussion: _zod.default.boolean(),
    questions: _zod.default.array(_zod.default.instanceof(_bson.ObjectId)),
    questionsCount: _zod.default.number(),
    relatedWorkflows: _zod.default.array(_zod.default.object({
        name: _zod.default.string(),
        _id: _zod.default.instanceof(_bson.ObjectId)
    })),
    relatedWorkflowCount: _zod.default.number()
});
